/*
 * Copyright (c) ProviderTrust LLC.
 * All Rights Reserved.
 *
 * This software is confidential and proprietary information of
 * ProviderTrust LLC ("Confidential Information"). You shall not disclose
 * such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered
 * into with ProviderTrust.
 */
import { menus } from "@/common/constants"

/**
 * get required roles from corresponding menuitem based on given path
 */
export function getRoles(path) {
  for (let menu of menus) {
    for (let menuItem of menu.menuItems) {
      if (menuItem.link === path) return menuItem.roles
      continue
    }
  }
}



// WEBPACK FOOTER //
// ./src/service/menu.js